var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplaceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.147 15.461l-1.458.911a.4.4 0 01-.54 0 .437.437 0 01-.095-.547l.833-3.135a.868.868 0 01.394-.525.809.809 0 01.634-.087l3.055.86a.416.416 0 01.306.357.437.437 0 01-.2.43l-1.465.831a4.994 4.994 0 005 3.011 5.1 5.1 0 004.418-3.871.423.423 0 01.4-.335h.831a.4.4 0 01.321.153.416.416 0 01.095.343 6.751 6.751 0 01-5.7 5.381 6.635 6.635 0 01-6.829-3.777zm11.667-6.926l1.495-.875a.4.4 0 01.54 0 .437.437 0 01.098.545l-.831 3.135a.868.868 0 01-.394.525.809.809 0 01-.634.087l-3.055-.86a.416.416 0 01-.306-.357.437.437 0 01.175-.437l1.458-.86a4.994 4.994 0 00-5-3.011 5.1 5.1 0 00-4.413 3.872.423.423 0 01-.4.335h-.829a.4.4 0 01-.3-.153.416.416 0 01-.095-.343 6.751 6.751 0 015.7-5.381 6.635 6.635 0 016.791 3.778z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16868",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgReplaceIcon;